import { INgRegistrationContext, IOmniaSession } from "../../types";
import { PlanValidationResult, PlansToValidate, PlanValidationService } from "./types";

/**
 * Provides services to validate plans to be updated
 * with respect to tasks/records those plans may already referenced by
 */
class Service implements PlanValidationService {

    static $inject = ["OmniaSession"]

    constructor(
        session: IOmniaSession,
        private readonly http = session.http
    ) {
    }

    /**
     * Validates a set of plans to be updated
     * for references from tasks or records
     */
    validate(plans: PlansToValidate) {

        const url = "/api/plans/v1/validate"

        const payload = {
            ...plans,
            plans: plans.plans.map(p => ({
                key: String(p.key),
                name: p.name
            }))
        }

        return this.http.post<{ plans: PlanValidationResult[] }>(url, payload, false).then(r => r.data.plans ?? [])

    }
}

export function setupPlanValidation(module: INgRegistrationContext) {
    module.service("OmniaPlanValidationService", Service)
}

export function createPlanValidationService(session: IOmniaSession) {
    return new Service(session)
}